import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M10 12.917H6.25c-1.163 0-1.744 0-2.218.143a3.33 3.33 0 0 0-2.222 2.222c-.143.473-.143 1.055-.143 2.218m14.166 0v-5m-2.5 2.5h5m-6.25-8.75a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0"
    }, null, -1)
  ]))]))
}
export default { render: render }